var _variants, _variants2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { Spacing } from '@tablekit/theme';
import { variant } from '@tablekit/utils';
import { animated } from 'react-spring';
import { SpinnerSize } from '../types.js';
var SPINNER_SIZE = {
  REGULAR: Spacing.L4,
  LARGE: Spacing.L5
};
var SpinnerContainer = animated(_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e6a1xi21"
} : {
  target: "e6a1xi21",
  label: "SpinnerContainer"
})("display:inline-flex;", variant({
  prop: 'size',
  default: SpinnerSize.Regular,
  variants: (_variants = {}, _defineProperty(_variants, SpinnerSize.Large, /*#__PURE__*/css("height:", SPINNER_SIZE.LARGE, ";width:", SPINNER_SIZE.LARGE, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SpinnerContainer;"))), _defineProperty(_variants, SpinnerSize.Regular, /*#__PURE__*/css("height:", SPINNER_SIZE.REGULAR, ";width:", SPINNER_SIZE.REGULAR, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SpinnerContainer;"))), _variants)
}), ";border-radius:10px;div+&{display:none;}"));

var SpinnerOuter = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e6a1xi20"
} : {
  target: "e6a1xi20",
  label: "SpinnerOuter"
})("display:inline-flex;justify-content:center;align-items:center;", variant({
  prop: 'size',
  default: SpinnerSize.Regular,
  variants: (_variants2 = {}, _defineProperty(_variants2, SpinnerSize.Large, /*#__PURE__*/css("line-height:", SPINNER_SIZE.LARGE, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SpinnerOuter;"))), _defineProperty(_variants2, SpinnerSize.Regular, /*#__PURE__*/css("line-height:", SPINNER_SIZE.REGULAR, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SpinnerOuter;"))), _variants2)
}), ";");

export { SpinnerContainer, SpinnerOuter };
